module.exports = __webpack_public_path__ + "static/media/MD.c2308e2d.svg";